var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#5e50a1"}},[_c('b-col',{attrs:{"cols":"12"}},[_c('b-container',{staticClass:"footer pt-3 pb-2 text-left text-white"},[_c('h3',[_vm._v("Top Jobs")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }